module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp13_9006.67a8f316.png";